import React from "react"
import CallToAction from "./CallToAction"
import { FormattedMessage } from 'react-intl'

const IntroBox = ({ className, image, title, children, link, more, moreText, textClassName }) => {
  return (
    <div className={`${className} flex flex-col md:flex-row`}>
      <div className="w-full md:w-1/4 mr-4">
        <img src={`/AnnualReport2017-2018${image}`} alt="" className="block rounded-full mx-auto" />
      </div>

      <div className={`${textClassName} w-full md:w-3/4 flex flex-col justify-between pt-0 text-justify`}>
        <div>
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2 text-center md:text-left mt-6 md:mt-0">{title}</h4>
          <div className="font-normal">{children}</div>
        </div>

        {
          !more ? null : (
            <CallToAction link={link}>
              <span className="uppercase">{moreText}</span>
            </CallToAction>
          )
        }
      </div>
    </div>
  )
}

IntroBox.defaultProps = {
  className: '',
  title: "[Title]",
  children: "[Content]",
  more: false,
  moreText: <FormattedMessage id="more" />,
  link: "",
  image: "https://source.unsplash.com/random/600x600",
}

export default IntroBox
